( function($) {

	$('.accordionContainer').hide();
	$('.open').show();
	$('.accordionButton').click(function() {
		var target = $(this).attr('alt');

		$('.accordionContainer:not(div#' + target + ')').hide( 300 );
		$('div#' + target ).show( 300 );
	});
	$('#search-needs').hide();
	$('.needsBtn').on('click', function() {
		$('.accordionContainer').hide( 300 );
		$('#search-needs').slideToggle();
	});

} )(jQuery);